// extracted by mini-css-extract-plugin
export default {"group-name":"FfMtp3ahi98in7WBK5qy"};